export default __webpack_public_path__ + "static/media/template_pro__0026_1---TomDwa.2071f253.png";